<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-alert
        v-if="form.availableMoney !== null && form.availableMoney !== undefined"
        :message="$t('用户提现.可提现金额') + '：' + form.availableMoney"
        type="info"
        show-icon
        style="margin-bottom: 16px;"
      />
      <a-form-model-item prop="money">
        <span slot="label">
          <a-tooltip>
            {{$t('用户提现.提现金额')}}<template slot="title">{{$t('用户提现.提现金额')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.money" :placeholder="$t('通用.输入.请输入')+$t('用户提现.提现金额')" disabled />
      </a-form-model-item>

      <a-form-model-item prop="withdrawType">
        <span slot="label">
          <a-tooltip>
            {{$t('用户提现.提现方式')}}<template slot="title">{{$t('用户提现.提现方式')}}</template>
          </a-tooltip>
        </span>
        <a-select
          :placeholder="$t('通用.输入.请选择')+$t('用户提现.提现方式')"
          v-model="form.withdrawType"
          disabled
        >
          <a-select-option value="1">{{$t('用户提现.支付宝')}}</a-select-option>
          <a-select-option value="2">{{$t('用户提现.微信')}}</a-select-option>
          <a-select-option value="3">{{$t('用户提现.银行卡')}}</a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 银行卡提现信息 -->
      <template v-if="form.withdrawType === '3'">
        <a-form-model-item prop="bankName">
          <span slot="label">
            <a-tooltip>
              {{$t('银行名称')}}<template slot="title">{{$t('银行名称')}}</template>
            </a-tooltip>
          </span>
          <a-input v-model="form.bankName" :maxLength="32" :placeholder="$t('如:中国银行')" disabled />
        </a-form-model-item>
        <a-form-model-item prop="accountNum">
          <span slot="label">
            <a-tooltip>
              {{$t('银行卡号')}}<template slot="title">{{$t('银行卡号')}}</template>
            </a-tooltip>
          </span>
          <a-input v-model="form.accountNum" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('银行卡号')" disabled />
        </a-form-model-item>
        <a-form-model-item prop="bankAddress">
          <span slot="label">
            <a-tooltip>
              {{$t('开户行')}}<template slot="title">{{$t('开户行')}}</template>
            </a-tooltip>
          </span>
          <a-input v-model="form.bankAddress" :maxLength="32" :placeholder="$t('如:郑州市嵩山路中国银行支行')+$t('开户行')" disabled />
        </a-form-model-item>
      </template>
      <a-form-model-item prop="accountName">
          <span slot="label">
            <a-tooltip>
              {{$t('持卡人/收款姓名')}}<template slot="title">{{$t('持卡人/收款姓名')}}</template>
            </a-tooltip>
          </span>
        <a-input v-model="form.accountName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('持卡人/收款姓名')" disabled />
      </a-form-model-item>
      <!-- 支付宝/微信提现信息 -->
      <template v-if="form.withdrawType === '1' || form.withdrawType === '2'">
        <a-form-model-item prop="paymentCode">
          <span slot="label">
            <a-tooltip>
              {{$t('收款码')}}<template slot="title">{{$t('收款码')}}</template>
            </a-tooltip>
          </span>
<!--          <img v-if="form.paymentCode" :src="form.paymentCode" alt="收款码" style="max-width: 200px; display: block;" />-->
          <OssUploadSingle v-model="form.paymentCode" type="img" :maxSize="200" :disabled="true"></OssUploadSingle>
        </a-form-model-item>
      </template>

      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>
            {{$t('用户提现.提现状态')}}<template slot="title">{{$t('用户提现.提现状态')}}</template>
          </a-tooltip>
        </span>
        <a-select
          :placeholder="$t('通用.输入.请选择')+$t('用户提现.提现状态')"
          v-model="form.status"
        >
          <a-select-option :value="0">{{$t('用户提现.未审核')}}</a-select-option>
          <a-select-option :value="1">{{$t('用户提现.审核未通过')}}</a-select-option>
          <a-select-option :value="2">{{$t('用户提现.审核已通过')}}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item prop="auditOpinion">
        <span slot="label">
          <a-tooltip>
            {{$t('用户提现.审核意见')}}<template slot="title">{{$t('用户提现.审核意见')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.auditOpinion" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('用户提现.审核意见')" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getWithdraw, addWithdraw, updateWithdraw } from '@/api/shop/shopWithdraw'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import {generateFilePath, uploadObject} from "@/api/tool/oss";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,
        userId: null,
        shopId: null,
        money: null,
        availableMoney: null,
        status: 0,
        bankName: null,
        accountNum: null,
        accountName: null,
        bankAddress: null,
        paymentCode: null,
        serviceChargeNum: null,
        withdrawType: null,
        withdrawUserType: null,
        orderNo: null,
        failureReason: null,
        auditOpinion: null,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        status: [{ required: true, message: this.$t('用户提现.提现状态') + this.$t('通用.输入.不能为空'), trigger: 'change' }],
        auditOpinion: [{ required: true, message: this.$t('用户提现.审核意见') + this.$t('通用.输入.不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        shopId: null,
        money: null,
        availableMoney: null,
        status: 0,
        bankName: null,
        accountNum: null,
        accountName: null,
        bankAddress: null,
        paymentCode: null,
        serviceChargeNum: null,
        withdrawType: null,
        withdrawUserType: null,
        orderNo: null,
        failureReason: null,
        auditOpinion: null,
        createTime: null,
        remark: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWithdraw({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.按钮.审核')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateWithdraw(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addWithdraw(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>